import React from "react";
import { Link } from "react-router-dom";
import { fetchAll, deleteOne } from "actions/reader";
import { connect } from "react-redux";
import DeleteModal from "components/DeleteModal";
import UpdateReaderModal from "components/UpdateReaderModal";

const mapStateToProps = state => ({
  reader: state.reader.byId,
  deleteErrors: state.reader.deleteErrors
});

const mapDispatchToProps = {
  fetchAll,
  deleteOne
};

class AdminReaderList extends React.Component {
  componentWillMount() {
    this.props.fetchAll();
  }

  render() {
    const readers = Object.keys(this.props.reader).map(
      id => this.props.reader[id]
    );

    const { deleteErrors } = this.props;
    return (
      <div>
        <Link to="/admin/reader/create">
          <button className="btn btn-danger mb-2">Legg til leser</button>
        </Link>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Selskap</th>
              <th scope="col">Lesernavn</th>
              <th scope="col">Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {readers.map(reader => (
              <tr key={reader.id}>
                <th scope="row">{reader.id}</th>
                <td>{reader.user.company}</td>
                <td>{reader.name}</td>
                <td>
                  <div className="btn-toolbar">
                    <UpdateReaderModal
                      onSubmit={this.props.updateOne}
                      title="Rediger"
                      reader={reader}
                    />
                    <DeleteModal
                      errors={deleteErrors}
                      onDelete={this.props.deleteOne}
                      title="Slett"
                      id={reader.id}
                    >
                      Er du sikker på at du vil slette {reader.name}?
                    </DeleteModal>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminReaderList);



// WEBPACK FOOTER //
// ./src/components/AdminReaderList.js